export default function IosGearOutline() {
  return (
    <div
      className="ion-icon-ios-gear-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M256.9,159.9c-25.701,0-49.801,10-67.9,28.1s-28.1,42.199-28.1,67.9c0,25.699,10,49.699,28.1,67.9
			c18.1,18.1,42.301,28.1,67.9,28.1c25.699,0,49.799-10,67.9-28.1c18.1-18.102,28.1-42.201,28.1-67.9c0-25.701-10-49.701-28.1-67.9
			C306.699,169.9,282.6,159.9,256.9,159.9z M256.9,335.9c-44.301,0-80-35.9-80-80c0-44.101,35.699-80,80-80
			c44.299,0,80,35.899,80,80C336.9,300,301.199,335.9,256.9,335.9z"/>
	</g>
	<g>
		<path d="M201.787,82.828c4.458,6.628,10.119,12.406,16.775,17.069c11.012,7.715,23.957,11.793,37.438,11.793
			c13.481,0,26.428-4.078,37.439-11.793c6.654-4.663,12.316-10.441,16.773-17.068c10.326,3.228,20.334,7.378,29.927,12.411
			c-1.532,7.84-1.614,15.93-0.203,23.933c2.333,13.235,8.604,25.269,18.133,34.798c12.335,12.336,28.737,19.129,46.185,19.129
			c4.242,0,8.424-0.399,12.52-1.195c5.032,9.6,9.181,19.613,12.405,29.947c-6.622,4.46-12.396,10.121-17.054,16.776
			c-7.705,11.008-11.777,23.946-11.776,37.418c0,13.467,4.069,26.401,11.768,37.406c4.653,6.651,10.421,12.312,17.036,16.771
			c-3.232,10.34-7.387,20.354-12.428,29.957c-4.081-0.789-8.246-1.187-12.472-1.187c-17.448,0-33.85,6.795-46.183,19.131
			c-9.515,9.514-15.781,21.527-18.123,34.74c-1.415,7.988-1.343,16.065,0.176,23.895c-9.607,5.04-19.627,9.192-29.967,12.421
			c-4.461-6.61-10.121-12.374-16.771-17.022c-11-7.689-23.928-11.754-37.386-11.754c-13.457,0-26.385,4.064-37.385,11.755
			c-6.649,4.648-12.31,10.412-16.771,17.021c-10.339-3.228-20.359-7.381-29.966-12.42c1.519-7.829,1.591-15.906,0.176-23.895
			c-2.342-13.214-8.608-25.228-18.123-34.741c-12.335-12.336-28.737-19.13-46.185-19.13c-4.226,0-8.39,0.396-12.471,1.187
			c-5.04-9.602-9.195-19.618-12.428-29.958c6.615-4.46,12.383-10.119,17.036-16.771c7.699-11.004,11.769-23.939,11.769-37.408
			c0-13.471-4.072-26.41-11.777-37.418c-4.658-6.654-10.432-12.316-17.054-16.776c3.225-10.333,7.372-20.346,12.405-29.946
			c4.096,0.796,8.277,1.196,12.521,1.196c17.446,0,33.849-6.794,46.185-19.13c9.529-9.53,15.799-21.563,18.133-34.799
			c1.411-8.003,1.33-16.093-0.203-23.932C181.455,90.207,191.461,86.057,201.787,82.828 M302.074,64
			C294.971,82.529,277.027,95.69,256,95.69c-21.025,0-38.969-13.161-46.073-31.69c-20.466,4.895-39.692,12.973-57.128,23.688
			c8.068,18.122,4.682,40.104-10.182,54.97c-9.631,9.631-22.25,14.443-34.87,14.443c-6.854,0-13.706-1.419-20.083-4.255
			C76.958,170.284,68.887,189.517,64,209.984c18.51,7.112,31.652,25.049,31.652,46.062c0,21.008-13.133,38.936-31.631,46.054
			c4.898,20.466,12.977,39.692,23.693,57.128c6.36-2.821,13.197-4.232,20.031-4.232c12.621,0,25.238,4.812,34.871,14.443
			c14.841,14.841,18.238,36.781,10.215,54.889c17.438,10.71,36.664,18.783,57.131,23.673c7.127-18.479,25.046-31.596,46.037-31.596
			c20.992,0,38.91,13.115,46.037,31.596c20.468-4.89,39.693-12.964,57.132-23.675c-8.023-18.106-4.626-40.046,10.216-54.887
			c9.629-9.632,22.248-14.444,34.868-14.444c6.836,0,13.67,1.411,20.033,4.233c10.716-17.436,18.794-36.662,23.692-57.128
			c-18.498-7.118-31.63-25.048-31.63-46.054c-0.001-21.013,13.143-38.948,31.651-46.062c-4.887-20.466-12.957-39.7-23.664-57.139
			c-6.375,2.836-13.23,4.254-20.082,4.254c-12.621,0-25.238-4.811-34.871-14.442c-14.863-14.863-18.248-36.846-10.18-54.97
			C341.768,76.973,322.54,68.895,302.074,64L302.074,64z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
